<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from '@/components/Page-header';
import appConfig from "../../../../../app.config";


/**
 * Form elements component
 */
export default {
 page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "Registro de roles",
      items: [
        {
          text: "",
          href: "/",
        },
        {
          text: "",
          href: "/",
        },
        {
          text: "",
          active: true,
        },
      ],
      };
  },
  methods: {
  goBack() {
      this.$router.go(-1);
    },
    goRegisterPage() {
      this.$router.push({
        name: "registro-rol",
        params: {
          id: this.$route.params.id,
        },
      });
    },
 
  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  
  <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-6">
               </div>

              <div class="col-6 text-right">
                <div @click="goBack" class="btn btn-secondary m-l-5 ml-1" id="tooltip">
                  <i class="fas fa-arrow-left"></i>
                </div>
                <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
              </div>
            </div>

            <div class="row">
              <div class="col-3"></div>
              <div class="col-md-6">
                <div class="card-body">
                  <form class="form-horizontal form-group" role="form" >
                    <b-form-group label-cols-sm="4" label-cols-lg="3" label="Nombre"
                      label-for="name">
                      <b-form-input type="text" id="name" placeholder="Ingrese el nombre" 
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group label-cols-sm="4" label-cols-lg="3" label="Correo" label-for="mail">
                      <b-form-input type="text" id="mail" placeholder="Ingrese el correo"
                       ></b-form-input>
                     
                    </b-form-group>

                  <b-form-group label-cols-sm="4" label-cols-lg="3" label="Rol" label-for="option">
                  <select  class="form-control">
                    <b-form-select-option >
                      Root Emisión
                    </b-form-select-option>
                    <b-form-select-option >
                      Soportista
                    </b-form-select-option>
                    <b-form-select-option >
                      Compañia
                    </b-form-select-option>
                    <b-form-select-option >
                      Empleado
                    </b-form-select-option>
                  </select>
                </b-form-group>

                    

                    

                    <div class="form-group text-right m-b-0">
                      <button id="save" class="btn btn-primary" type="submit">
                        Guardar
                      </button>
                       <button type="button" @click="goBack" class="btn btn-secondary m-l-5 ml-1">
                        Cancelar
                      </button>
                       
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="col-1"></div>
          </div>
        </div>
      </div>
    </div>
 
  </Layout>
</template>
